var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "350" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "div",
        { staticClass: "scartati" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "cyan headline" },
                [
                  _c("span", { staticClass: "white--text" }, [
                    _vm._v("Scarta calciatori"),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { depressed: "", light: "", icon: "" },
                      on: { click: _vm.dismiss },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("asta-svincolati", {
                attrs: {
                  maxQuotazione: 999999999999,
                  dialogParent: _vm.dialog,
                  showButtonsScartaRiabilita: "",
                  showStats: false,
                  showMainStatus: false,
                  showButtonScartati: false,
                  showQuotazioni: "",
                  textScuro: "",
                  ripple: "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }